import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const warehousesSchedulesAdapter = getAdapter();

const warehousesSchedulesSlice = createSlice({
  name: 'warehousesSchedules',
  initialState: warehousesSchedulesAdapter.getInitialState(),
  reducers: {
    setWarehousesSchedules: (state, { payload: { warehousesSchedules } }) => {
      warehousesSchedulesAdapter.setAll(state, warehousesSchedules);
    },
  },
});

const selectors = warehousesSchedulesAdapter.getSelectors(({ warehousesSchedules }) => warehousesSchedules);

export const getWarehousesSchedules = (state) => selectors.selectAll(state);

export const {
  setWarehousesSchedules,
} = warehousesSchedulesSlice.actions;

export default warehousesSchedulesSlice.reducer;